/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class s{constructor(s,t){this.inner=s,this.displayId=t}}export{s as WithDisplayId};
